import { craftLocales, craftSiteIdForPath } from '~/config/craftLocales';

const LOCATION_PATH_PATTERN = /^(\/en)?\/(locaties|locations)\/[^/]+/;

export default defineNuxtRouteMiddleware(async to => {
    const locationI18nParams = useLocationI18nParams();

    if (!LOCATION_PATH_PATTERN.test(to.path)) {
        return;
    }

    const routeSlug = String(to.params.slug ?? '');

    if (!routeSlug) {
        return;
    }

    const siteId = craftSiteIdForPath(to.path);
    const { entry } = await fetchLocationEntry(routeSlug, craftLocales, siteId);

    if (entry) {
        const i18nParams = resolveLocalizedSlug(entry, craftLocales);

        locationI18nParams.value = i18nParams;
        to.meta.nuxtI18n = i18nParams;
    }
});
